/*
 * Shared logic for the "olejek" (essential oil) PDP template.
 * Handles: hero buy box (subscription vs one-time), qty stepper, delivery
 * frequency (selling plan), add-to-cart everywhere on the page (hero, CTA
 * band, sticky bar, "jak uzywac" section), generic accordions and the
 * bibliography show-more toggle.
 *
 * All state lives in window.OilPDP so every olejek-*.liquid section can
 * read/update the same product selection without passing data between
 * Liquid files.
 */
if (window.OilPDP) {
  /* oil-pdp.js is intentionally included by several olejek-*.liquid sections
     so each one works standalone. Every section on the same page loads (and
     executes) this same script tag again, so everything below must only run
     once — otherwise every click handler would fire once per included
     section (accordions would toggle back to their original state, add to
     cart would add multiple line items, etc). */
} else {
window.OilPDP = (function () {
  var state = {
    mode: 'sub',
    qty: 1,
    variantId: null,
    sellingPlanId: null,
    priceOnce: 0,
    priceSub: 0,
    sellingPlanPrices: {},
    modeLabelOnce: 'Zakup jednorazowy',
    modeLabelSub: 'Subskrypcja'
  };

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function unitPrice() {
    if (state.mode === 'sub') {
      if (state.sellingPlanId && state.sellingPlanPrices[state.sellingPlanId] != null) {
        return state.sellingPlanPrices[state.sellingPlanId];
      }
      return state.priceSub;
    }
    return state.priceOnce;
  }

  function subUnitPrice() {
    if (state.sellingPlanId && state.sellingPlanPrices[state.sellingPlanId] != null) {
      return state.sellingPlanPrices[state.sellingPlanId];
    }
    return state.priceSub;
  }

  function total() {
    return unitPrice() * state.qty;
  }

  function getState() {
    return {
      mode: state.mode,
      qty: state.qty,
      unitPrice: unitPrice(),
      total: total(),
      totalFormatted: fmt(total()),
      unitFormatted: fmt(unitPrice()),
      subUnitFormatted: fmt(subUnitPrice()),
      modeLabel: state.mode === 'sub' ? state.modeLabelSub : state.modeLabelOnce
    };
  }

  function notify() {
    renderUI();
    document.dispatchEvent(new CustomEvent('oil-pdp:state', { detail: getState() }));
  }

  function init(config) {
    state.variantId = config.variantId || state.variantId;
    state.priceOnce = config.priceOnce || 0;
    state.priceSub = config.priceSub || 0;
    state.sellingPlanPrices = config.sellingPlanPrices || {};
    state.sellingPlanId = config.sellingPlanId || null;
    if (config.mode) state.mode = config.mode;
    notify();
  }

  function setMode(mode) {
    state.mode = mode;
    notify();
  }

  function setQty(qty) {
    state.qty = Math.max(1, Math.min(99, qty));
    notify();
  }

  function stepQty(delta) {
    setQty(state.qty + delta);
  }

  function setSellingPlan(id) {
    state.sellingPlanId = id || null;
    notify();
  }

  function addToCart(btn) {
    if (!state.variantId) return;
    var item = { id: state.variantId, quantity: state.qty };
    if (state.mode === 'sub' && state.sellingPlanId) {
      item.selling_plan = state.sellingPlanId;
    }

    var originalText = null;
    if (btn) {
      originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Dodawanie...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && data.description) || 'Błąd dodawania do koszyka');
          });
        }
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('rc:cart:open', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[oil-pdp]', err);
        alert('Wystąpił błąd. Spróbuj ponownie.');
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (originalText !== null) btn.textContent = originalText;
        }
      });
  }

  /* ---- DOM rendering: keeps every [data-oil-*] element on the page in sync ---- */
  function renderUI() {
    var s = getState();

    document.querySelectorAll('[data-oil-plan]').forEach(function (card) {
      card.classList.toggle('is-active', card.getAttribute('data-oil-plan') === s.mode);
    });

    document.querySelectorAll('[data-oil-qty-value]').forEach(function (el) {
      el.textContent = s.qty;
    });

    document.querySelectorAll('[data-oil-cta-price]').forEach(function (el) {
      el.textContent = s.totalFormatted;
    });

    document.querySelectorAll('[data-oil-unit-price]').forEach(function (el) {
      el.textContent = s.unitFormatted;
    });

    document.querySelectorAll('[data-oil-price-sub]').forEach(function (el) {
      el.textContent = s.subUnitFormatted;
    });

    document.querySelectorAll('[data-oil-mode-label]').forEach(function (el) {
      el.textContent = s.modeLabel;
    });

    document.querySelectorAll('[data-oil-nudge]').forEach(function (el) {
      el.classList.toggle('is-visible', s.mode === 'once');
    });
  }

  /* ---- Wiring ---- */
  function initBuyBox() {
    var root = document.querySelector('[data-oil-buybox]');
    if (!root) return;

    root.querySelectorAll('[data-oil-plan]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('button, select, a, input')) return;
        setMode(card.getAttribute('data-oil-plan'));
      });
    });

    root.querySelectorAll('[data-oil-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        stepQty(-1);
      });
    });
    root.querySelectorAll('[data-oil-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        stepQty(1);
      });
    });

    root.querySelectorAll('[data-oil-freq-select]').forEach(function (select) {
      select.addEventListener('change', function (e) {
        e.stopPropagation();
        setSellingPlan(select.value);
      });
      if (select.value) setSellingPlan(select.value);
    });

    root.querySelectorAll('[data-oil-switch-sub]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setMode('sub');
      });
    });
  }

  function initAddToCartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oil-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn);
    });
  }

  function initScrollTopButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oil-scroll-top]');
      if (!btn) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-oil-toggle]');
      if (!trigger) return;
      var item = trigger.closest('[data-oil-accordion-item]');
      if (!item) return;
      var isOpen = item.classList.toggle('is-open');
      var sign = trigger.querySelector('[data-oil-sign]');
      if (sign) sign.textContent = isOpen ? '−' : '+';
    });
  }

  function initRefsToggle() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oil-refs-toggle]');
      if (!btn) return;
      var wrap = btn.closest('[data-oil-refs]');
      if (!wrap) return;
      var extra = wrap.querySelector('[data-oil-refs-extra]');
      if (!extra) return;
      var opening = !extra.classList.contains('is-open');
      extra.classList.toggle('is-open', opening);
      var label = btn.querySelector('[data-oil-refs-label]');
      if (label) label.textContent = opening ? 'Zwiń przypisy' : 'Rozwiń przypisy';
      var chevron = btn.querySelector('[data-oil-refs-chevron]');
      if (chevron) chevron.style.transform = opening ? 'rotate(180deg)' : 'rotate(0deg)';
    });
  }

  function initCtaBottleParallax() {
    var img = document.querySelector('.oil-cta-bottle-img');
    if (!img) return;
    var onScroll = function () {
      var wrap = img.parentElement;
      var section = wrap.closest('section');
      if (!section) return;
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      var overflow = Math.max(0, img.offsetHeight - wrap.clientHeight);
      var shift = -p * overflow;
      var narrow = window.innerWidth <= 1100;
      img.style.transform = narrow
        ? 'translateY(' + shift.toFixed(1) + 'px)'
        : 'translate(-50%,' + shift.toFixed(1) + 'px)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    requestAnimationFrame(onScroll);
  }

  function initStickySidebar() {
    var el = document.querySelector('.oil-formula-sticky');
    if (!el) return;
    var parent = el.parentElement;
    parent.style.position = 'relative';
    var topOffset = 96;

    function update() {
      if (window.innerWidth <= 1100) {
        el.style.position = '';
        el.style.top = '';
        el.style.left = '';
        el.style.width = '';
        return;
      }

      /* Reset to natural (in-flow) state before measuring, so every
         measurement below reflects the real document position rather than
         whatever fixed/absolute offsets were applied on the previous frame. */
      el.style.position = '';
      el.style.top = '';
      el.style.left = '';
      el.style.width = '';

      var scrollY = window.scrollY || window.pageYOffset;
      var rect = el.getBoundingClientRect();
      var parentRect = parent.getBoundingClientRect();
      var naturalLeft = rect.left;
      var naturalWidth = rect.width;
      var elHeight = el.offsetHeight;
      var parentHeight = parent.offsetHeight;
      var naturalDocTop = rect.top + scrollY;
      var parentDocTop = parentRect.top + scrollY;

      var stickyStart = naturalDocTop - topOffset;
      var stickyEnd = parentDocTop + parentHeight - elHeight - topOffset;

      if (stickyEnd <= stickyStart || scrollY <= stickyStart) {
        el.style.position = '';
        el.style.top = '';
        el.style.left = '';
        el.style.width = '';
      } else {
        /* Stay in position:fixed the whole time — left never has to change
           (horizontal position is scroll-invariant), so there is no
           coordinate-system conversion that could introduce drift. Past
           stickyEnd, top decreases 1:1 with scroll so the element's
           position in the DOCUMENT stays constant, i.e. it appears to stop
           and scroll away with the page exactly at the bottom of its
           column instead of overshooting past it. */
        var top = topOffset - Math.max(0, scrollY - stickyEnd);
        el.style.position = 'fixed';
        el.style.top = top + 'px';
        el.style.left = naturalLeft + 'px';
        el.style.width = naturalWidth + 'px';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  }

  function initStickyBar() {
    var bar = document.querySelector('.oil-stickybar');
    var hero = document.querySelector('.oil-hero');
    if (!bar || !hero) return;

    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    });
    observer.observe(hero);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBuyBox();
    initAddToCartButtons();
    initScrollTopButtons();
    initAccordions();
    initRefsToggle();
    initStickySidebar();
    initCtaBottleParallax();
    initStickyBar();
    renderUI();
  });

  return { init: init, setMode: setMode, setQty: setQty, stepQty: stepQty, setSellingPlan: setSellingPlan, addToCart: addToCart, getState: getState, fmt: fmt };
})();
}
